<template>
  <div @click="hideKeyboard" :class="[$style.wrapper, !isOpen ? $style.hide : null]">
    <div :class="$style.content" :style="contentStyle">
      <div v-if="this.isOpen" :class="$style.back" @click="backToCatalog">
        <img src="../assets/img/back.svg" alt="" />
      </div>

      <div v-if="photoUrls.length" :class="$style.photo">
        <div v-for="(photo, index) in photoUrls" :key="index" :class="$style.photo_preview">
          <img :src="photo" alt="Фото" :class="$style.photo_item" />
          <button :class="$style.remove_button" @click="removePhoto(index)">
            <img src="../assets/img/delete.svg" alt="" :class="$style.delete_icon" />Удалить фото
          </button>
        </div>
      </div>

      <div :class="$style.custom">
        <label for="photo_urls" :class="$style.custom_button" @click="triggerHapticFeedback">
          <img src="../assets/img/add_photo.svg" alt="" :class="$style.img" />Добавить фото
        </label>
        <input
          type="file"
          id="photo_urls"
          @change="handleFileChange"
          :class="$style.hidden"
          multiple
        />
      </div>

      <LayoutEditor v-model="layoutItems" input-id="add_layouts" />

      <div :class="$style.field">
        <p :class="$style.title">Проект</p>
        <input
          v-model="project"
          type="text"
          placeholder="Тег, клиентам не виден"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
        />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Категория</p>
        <select
          v-model="category"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
        >
          <option v-for="category in categories" :key="category" :value="category">
            {{ category }}
          </option>
        </select>
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Название</p>
        <input
          v-model="header"
          type="text"
          ref="header"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
        />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Описание</p>
        <div :class="$style.editor_container">
          <Editor
            v-model="description"
            type="text"
            ref="description"
            @focus="handleFocus"
            @blur="handleBlur"
            @selectionChange="handleSelectionChange"
            :class="$style.editor"
            :modules="editorModules"
          ></Editor>
        </div>
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Цена</p>
        <input
          v-model="formattedPrice"
          type="text"
          ref="price"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
          @input="formatPriceInput"
        />
      </div>

      <div :class="$style.field">
        <button :class="$style.button" @click="submitForm">
          <img src="../assets/img/plus.svg" alt="" :class="$style.img" />Добавить карточку
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from 'primevue/editor';
import LayoutEditor from './LayoutEditor.vue';
export default {
  components: { Editor, LayoutEditor },
  data() {
    return {
      isOpen: true,
      photoUrls: [],
      category: 'Новостройки',
      categories: ['Новостройки', 'Вторичные', 'Коммерция'],
      header: '',
      project: '',
      description: '',
      photos: [],
      layoutItems: [],
      contentStyle: {},
      price: '',
      formattedPrice: '',
      editorModules: {
        toolbar: [['bold', 'underline', 'strike']],
      },
    };
  },
  methods: {
    triggerHapticFeedback() {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
    },

    handleFileChange(event) {
      const files = event.target.files;
      if (files.length) {
        this.photos = [...this.photos, ...Array.from(files)];
        this.photoUrls = [
          ...this.photoUrls,
          ...Array.from(files).map((file) => URL.createObjectURL(file)),
        ];
      }
    },

    hideKeyboard() {
      if (window.Telegram && window.Telegram.WebApp) {
        window.Telegram.WebApp.closeKeyboard();
      }
    },

    removePhoto(index) {
      this.photos.splice(index, 1);
      this.photoUrls.splice(index, 1);
    },

    handleSelectionChange($event) {
      if ($event.range) {
        this.contentStyle = {
          padding: '70px 16px 300px 16px',
        };
      } else {
        this.contentStyle = {
          padding: '70px 16px 16px 16px',
        };
      }
    },

    backToCatalog() {
      this.triggerHapticFeedback();
      this.isOpen = false;
      setTimeout(() => {
        this.$emit('backToCatalog');
      }, 250);
    },

    async submitForm() {
      const formData = new FormData();
      this.photos.forEach((file) => {
        formData.append('files', file);
      });
      const meta = [];
      this.layoutItems.forEach((l) => {
        if (l.file) {
          formData.append('layouts', l.file);
          meta.push(this.layoutMeta(l));
        }
      });
      formData.append('layouts_meta', JSON.stringify(meta));
      formData.append('project', this.project);
      formData.append('category', this.category);
      formData.append('header', this.header);
      formData.append('description', this.description);
      formData.append('price', this.price);

      this.$store.commit('changeLoading', true);
      await this.$store.dispatch('addObject', formData);
      this.$store.commit('changeLoading', false);

      this.backToCatalog();
    },

    layoutMeta(l) {
      return {
        kind: l.kind,
        area: l.area,
        price: String(l.price || '').replace(/\s/g, ''),
        discount: l.discount,
        building: l.building,
        floor: l.floor,
        view: l.view,
      };
    },

    formatPriceInput() {
      let value = this.formattedPrice.replace(/\D/g, '');
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      this.formattedPrice = value;
      this.price = value.replace(/\s/g, '');
    },

    handleFocus() {
      this.triggerHapticFeedback();
      this.contentStyle = {
        padding: '70px 16px 300px 16px',
      };
    },

    handleBlur() {
      window.scrollTo(0, 0);
      this.contentStyle = {
        padding: '70px 16px 16px 16px',
      };
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}

@keyframes hide {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

.wrapper {
  position: fixed;
  overflow-y: auto;
  background: $background;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  animation-name: show;
  animation-duration: 0.25s;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &.hide {
    animation-name: hide;
    animation-duration: 0.26s;
  }
}

.content {
  padding: 70px 16px 50px 16px;
}

.back {
  position: fixed;
  z-index: 2;
  top: 16px;
  left: 16px;
  width: 39px;
  height: 39px;
}

.img {
  margin-right: 8px;
  width: 12px;
  height: 12px;
}

.hidden {
  display: none;
}

.custom_button {
  margin: 0 auto;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $white;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}

.photo {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  .photo_preview {
    position: relative;
    width: 100%;
    height: 250px;
    overflow: hidden;
    border-radius: 12px;

    .photo_item {
      width: 100%;
      height: -webkit-fill-available;
      object-fit: cover;
    }
  }
}

.remove_button {
  position: absolute;
  display: flex;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 16px 30px;
  background-color: $red;
  color: $white;
  border: none;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  .delete_icon {
    width: 12px;
    margin: 0 8px 0 0;
  }
}

.section {
  font-weight: 600;
  font-size: 13px;
  color: $muted;
  margin: 8px 0 10px;
}

.field {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.field:last-child {
  margin-bottom: 40px;
}

.title {
  width: 72px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  padding: 14px 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $white;
}

.button_transparent {
  flex-grow: 1;
  padding: 14px 0px 14px 16px;
  background-color: transparent;
  color: $white;
  border: 1px solid #3a3a3a;
  background-color: $bg-dark;
  border-radius: 12px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  overflow: auto;
}

.editor_container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #3a3a3a;
  background-color: $bg-dark;
  border-radius: 12px;
  color: white;
  overflow: hidden;
  background-color: transparent;
}

.editor .ql-toolbar {
  background-color: transparent;
  border-bottom: 1px solid $white;
  padding: 0 8px;
}

.editor .ql-container {
  padding: 14px 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: white;
  --webkit-text-color: white;
  background-color: transparent;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.button_transparent::placeholder {
  color: $white;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.button {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $white;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}
</style>

<style>
.p-editor-toolbar {
  display: none !important;
}
</style>
